import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import record from '../../versa/record.js';
import { notify } from '../../versa/msgbox.js';
import view from '../views/product-packagings.js';
import form from '../forms/product-packagings.js';
import print_report_form from '../forms/product-packagings-print-report.js';
import * as types from '../types.js';

/** Resolve rótulo ou id do fabricante (GTIN) no escopo da empresa. */
async function resolvePackagingManufacturerId(companyId, raw)
{
	if (raw == null || String(raw).trim() === '')
		return null;
	const s = String(raw).trim();
	if (/^\d+$/.test(s))
	{
		const n = Number(s);
		if (!Number.isFinite(n) || n < 1)
			return null;
		const scope = companyId != null && String(companyId).trim() !== '' ? String(companyId).trim() : null;
		const opts = await db.list('manufacturers').catch(() => []);
		const match = opts.find(o =>
			Number(o.id) === n && (!scope || String(o.company_id) === scope));
		return match?.id != null ? Number(match.id) : null;
	}
	const scope = companyId != null && String(companyId).trim() !== '' ? String(companyId).trim() : null;
	const opts = await db.list('manufacturers').catch(() => []);
	const match = opts.find(o =>
		(!scope || String(o.company_id) === scope)
		&& ((o.nick || '') === s || String(o.nick || '') === s || (o.name || '') === s || String(o.name || '') === s));
	return match?.id != null ? Number(match.id) : null;
}

const product_packagings = function()
{
	let product_packagings_crud = crud.create({
		async loadBaseData()
		{
			await Promise.all([
				api.call(api.list_companies, this.queryAll()).then((data) => (data ? db.set('companies', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
				api.call(api.list_products, this.queryAll()).then((data) => (data ? db.set('products', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
				api.call(api.list_manufacturers, this.queryAll()).then((data) => (data ? db.set('manufacturers', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
				api.call(api.list_product_packagings, this.queryAll()).then((data) => (data ? db.set('product_packagings', data) : Promise.resolve())).catch((e) => notify(e?.message || e)),
			]);
		},
		async queryData(query)
		{
			return await api.call(api.list_product_packagings, query);
		},
		async loadRecord(id)
		{
			return await api.call(api.select_product_packaging, ...JSON.parse(id));
		},
		async saveRecord(data, old_data)
		{
			const companyId = data.company_id;
			const manufacturerId = await resolvePackagingManufacturerId(companyId, data.manufacturer_id);
			let _record = {
				product_id: Number(data.product_id),
				manufacturer_id: manufacturerId,
				code: data.code,
				level: data.level,
				factor: Number(data.factor),
				tertiary_capacity: data.tertiary_capacity ? Number(data.tertiary_capacity) : null,
				gtin: data.gtin || null,
				qr_code: data.qr_code || null,
				is_default: data.is_default == '1',
				is_disabled: data.is_disabled == '1',
			};
			if (old_data)
				return await api.call(api.update_product_packaging, data.company_id, data.id, _record);
			return await api.call(api.insert_product_packaging, data.company_id, _record);
		},
	});

	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'id', label: 'ID', types: [types.number(0, 2)] },
		{ index: 3, field: 'sku', label: 'SKU', types: [] },
		{ index: 4, field: 'product_id', label: 'Produto', types: [types.datalist()], store: 'products', labels: ['name'] },
		{ index: 5, field: 'manufacturer_id', label: 'Fabricante', types: [types.datalist()], store: 'manufacturers', labels: ['nick'] },
		{ index: 6, field: 'code', label: 'Código', types: [] },
		{ index: 7, field: 'level', label: 'Nível', types: [] },
		{ index: 8, field: 'factor', label: 'Fator', types: [types.number(0, 2)] },
		{ index: 9, field: 'tertiary_capacity', label: 'Cap. Terciária', types: [types.number(0, 2)] },
		{ index: 10, field: 'gtin', label: 'GTIN', types: [types.gtin()] },
		{ index: 11, field: 'is_default', label: 'Padrão', types: [types.opt_bool(), types.datalist()] },
		{ index: 12, field: 'is_disabled', label: 'Inativa', types: [types.opt_bool(), types.datalist()] },
	];

	const reports = [
		{ hash: '#print-product-packagings-report', label: 'Relatório&nbsp;de&nbsp;Embalagens&nbsp;(CSV)' },
	];

	async function resolveCompanyId(raw) {
		if (raw == null || String(raw).trim() === '') return null;
		const v = String(raw).trim();
		const c = await db.get('companies', v);
		return c?.id ?? v;
	}

	router.set('#print-product-packagings-report', () => {
		record.edit(
			print_report_form,
			async (data) => {
				const companyId = await resolveCompanyId(data.company_id);
				if (!companyId) {
					notify('Selecione a empresa.', 'Aviso');
					return false;
				}
				const params = new URLSearchParams();
				params.set('format', 'csv');
				const pid = data.product_id != null ? String(data.product_id).trim() : '';
				if (pid !== '') params.set('product_id', pid);
				if (data.level) params.set('level', String(data.level).trim().toUpperCase());
				if (data.status) params.set('status', String(data.status).trim().toLowerCase());
				const mr = parseInt(data.max_rows, 10);
				if (!isNaN(mr) && mr > 0) params.set('max_rows', String(mr));
				try {
					const res = await api.product_packagings_report(companyId, params.toString());
					const blob = await res.blob();
					if (!res.ok) {
						let msg = await blob.text();
						try {
							const j = JSON.parse(msg);
							msg = j?.message || msg;
						} catch (_) { /* plain text */ }
						notify(msg || res.statusText, 'Erro');
						return false;
					}
					const url = URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = `embalagens-produto-${String(companyId).slice(0, 8)}.csv`;
					a.click();
					URL.revokeObjectURL(url);
					notify('Download iniciado.', 'Sucesso');
				} catch (e) {
					notify(e?.message || String(e), 'Erro');
					return false;
				}
				return true;
			},
			{},
			false,
		);
	});

	product_packagings_crud.run(
		'product_packagings',
		'Embalagens',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		[],
		reports
	);
};

export default product_packagings;
